export default "__VITE_ASSET__Ek5sy39t__"